import React from 'react';
import { motion } from 'framer-motion';
import { Badge } from '../components/ui/badge';
import { SectionHeader } from '../components/common/SectionHeader';
import { CTASection } from '../components/common/CTASection';
import { ResourceCard } from '../components/resources/ResourceCard';
import { GeometricBackground } from '../components/decorations/GeometricBackground';
import { resources } from '../data/resources';

const ResourcesPage = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-hero-pattern overflow-hidden">
        <GeometricBackground />
        <div className="container-custom relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-3xl mx-auto text-center"
          >
            <Badge className="mb-4 bg-primary-foreground/10 text-primary-foreground border-primary-foreground/20">
              Resources
            </Badge>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-primary-foreground mb-6">
              Download Resources
            </h1>
            <p className="text-lg text-primary-foreground/80">
              Access our company profile, client experiences, and digital brochures.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Resources Grid */}
      <section className="section-padding bg-background">
        <div className="container-custom">
          <SectionHeader
            subtitle="Documents"
            title="Available Resources"
            description="Download our materials to learn more about Voitech Solutions and our capabilities."
            className="mb-16"
          />

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {resources.map((resource, index) => (
              <ResourceCard key={resource.id} resource={resource} index={index} />
            ))}
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="section-padding bg-card">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
            >
              <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-4">
                Need Additional Information?
              </h2>
              <p className="text-muted-foreground mb-8">
                If you need specific documentation or have questions about our services and products, our team is ready to help.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <CTASection
        title="Have Questions?"
        description="Contact us for more information about our services and solutions."
        primaryButtonText="Contact Us"
        primaryButtonLink="/contact"
      />
    </div>
  );
};

export default ResourcesPage;
